export interface TUSpecial {
  id: number;
  sku: string;
  creationDate: string;
  creationBy: string;
  supplier: string;
  description: string;
  class2: string;
  supplierSKU: string;
  purchasePrice: number;
  supplierPrice: number;
  salesPrice: number;
  margin?: number;
  orderUnit: number;
  deliveryDays: number;
}

export const EmptyTUSpecial = (): TUSpecial => ({
  id: 1,
  sku: '',
  creationDate: '',
  creationBy: '',
  supplier: 'SUPPLIER_TU',
  description: '',
  class2: '',
  supplierSKU: '',
  purchasePrice: null as unknown as number,
  supplierPrice: null as unknown as number,
  salesPrice: null as unknown as number,
  orderUnit: 1,
  deliveryDays: 0,
});
